import React from 'react';
import {
  Box,
  Button,
  Grid,
  Typography,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ResumeImage from '../../assets/resume1.png';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from '@mui/material';
import Navbar from '../../Components/Navbar';

const steps = [
  'Select a template from our library of professional designs',
  'Build your resume with our industry-specific bullet points',
  'Customize the details and wrap it up. You\'re ready to send!',
];

const StepsSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const navigate = useNavigate();

  const handleNextClick = () => {
    navigate('/experience-level');
  };

  return (
    <>
      {/* Top Navbar */}
      <Navbar />

      {/* Back Button */}
      <IconButton
        onClick={() => navigate('/')}
        sx={{
          position: 'absolute',
          top: { xs: 70, sm: 80 },
          left: 20,
          zIndex: 1300,
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 8px rgba(0,43,91,0.15)',
          border: '1.5px solid #B3D9F7',
          '&:hover': { 
            backgroundColor: '#EFF7FF',
            borderColor: '#0288D1',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <ArrowBackIcon sx={{ color: '#002B5B' }} />
      </IconButton>

      <Box
        sx={{
          py: 6,
          px: 3,
          backgroundColor: '#EFF7FF',
          display: 'flex',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ maxWidth: '1200px' }}
        >

          {/* Left: Text Content */}
          <Grid item xs={12} md={6}>
            <Box textAlign={isMobile ? 'center' : 'left'}>
              <Typography 
                variant="h4" 
                fontWeight="bold" 
                gutterBottom
                sx={{ 
                  color: '#002B5B',
                  borderBottom: isMobile ? 'none' : '3px solid #0288D1',
                  pb: isMobile ? 0 : 1,
                  display: 'inline-block',
                }}
              >
                Just three easy steps
              </Typography>

              <Stack spacing={2} mt={3}>
                {steps.map((step, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: isMobile ? 'center' : 'flex-start',
                    }}
                  >
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backgroundColor: '#002B5B',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        fontSize: '0.9rem',
                        mr: 2,
                        flexShrink: 0,
                        boxShadow: '0 2px 8px rgba(0,43,91,0.25)',
                      }}
                    >
                      {index + 1}
                    </Box>
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        color: '#0D4C8B',
                        fontSize: isMobile ? '0.95rem' : '1rem',
                        lineHeight: 1.6,
                      }}
                    >
                      {step}
                    </Typography>
                  </Box>
                ))}
              </Stack>

              {/* Next Button with updated colors */}
              <Button
                variant="contained"
                onClick={handleNextClick}
                sx={{
                  background: 'linear-gradient(135deg, #002B5B 0%, #0288D1 100%)',
                  color: '#fff',
                  fontWeight: 700,
                  px: 4,
                  py: 1.5,
                  mt: 4,
                  borderRadius: '12px',
                  width: isMobile ? '100%' : 'auto',
                  maxWidth: isMobile ? '100%' : '300px',
                  textTransform: 'none',
                  fontSize: '1rem',
                  boxShadow: '0 4px 16px rgba(0,43,91,0.3)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #001a36 0%, #026aa1 100%)',
                    boxShadow: '0 6px 24px rgba(2,136,209,0.4)',
                    transform: 'translateY(-2px)',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                Next →
              </Button>
            </Box>
          </Grid>

          {/* Right: Resume Image */}
          <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
            <Box
              component="img"
              src={ResumeImage}
              alt="Resume Example"
              sx={{ 
                width: '100%', 
                maxWidth: 450, 
                borderRadius: 3, 
                boxShadow: '0 8px 32px rgba(0,43,91,0.15)',
                border: '2px solid #B3D9F7',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.02)',
                  boxShadow: '0 12px 48px rgba(0,43,91,0.2)',
                }
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default StepsSection;